import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useScale } from '../../hooks/useScale';
import theme from '../../common/theme';

const StatsStyles = () => {
  const { scale } = useScale();

  return useMemo(
    () =>
      StyleSheet.create({
        statsContainer: {
          flexDirection: 'row',
          alignItems: 'center',
          paddingHorizontal: 10,
          backgroundColor: theme.colors.tertiary2,
          borderRadius: theme.radius.s,
          borderColor: theme.colors.black2,
          borderWidth: scale(2),
          height: scale(38),
          columnGap: 4,
        },
        statGroup: {
          flexDirection: 'row',
          alignItems: 'center',
          marginRight: 4,
        },
        statLabel: {
          color: theme.colors.grey5,
          fontFamily: 'Inter-Medium',
          fontSize: scale(14),
          lineHeight: scale(20),
          marginRight: 4,
        },
        statValue: {
          color: theme.colors.lightBlueDark,
          fontFamily: 'Inter-SemiBold',
          fontSize: scale(14),
          lineHeight: scale(20),
        },
        longest: {
          // color: theme.colors.red,
          fontFamily: 'Inter-SemiBold',
          fontSize: scale(14),
          lineHeight: scale(20),
        },
        separator: {
          width: 2,
          height: scale(34),
          backgroundColor: theme.colors.black2,
          marginHorizontal: 8,
        },
        bgStyle: {
          width: '100%',
          position: 'absolute',
          height: theme.window.vh,
        },
        optionsContainer: {
          width: scale(150),
          borderRadius: theme.radius.s,
          backgroundColor: theme.colors.white,
        },
        popupContent: {
          padding: scale(10),
          borderRadius: theme.radius.s,
          backgroundColor: theme.colors.white,
          ...theme.shadow.light,
          color: theme.colors.black,
        },
        popupLabel: {
          color: theme.colors.black,
          fontFamily: 'Inter-Medium',
          fontSize: scale(14),
          lineHeight: scale(20),
          marginRight: 4,
        },
        popupStatGroup: {
          flexDirection: 'row',
          alignItems: 'center',
          marginRight: 4,
          justifyContent: 'space-between',
        },
      }),
    [scale],
  );
};

export default StatsStyles;
